import { uniqBy } from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ToastView from './ToastView';
import { deleteToast } from './toastSlice';

const Toast = () => {
  let toastList = useSelector((state) => state.toast);

  // 동일 toast id가 있는 경우 중복 제거
  toastList = uniqBy(toastList, 'id');

  const dispatch = useDispatch();

  const onDeleteToast = (id) => dispatch(deleteToast({ id }));

  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      if (toastList.length) {
        toastList.forEach((toast, idx) => {
          index = idx;
          if (toast.autoClose) {
            onDeleteToast(toast.id);
          }
        });
      }
    }, toastList[index]?.time || 3000);

    return () => {
      clearInterval(interval);
    };
  }, [toastList]);

  return toastList.length ? (
    <ToastView
      list={toastList}
      position="bottomCenter"
      onDeleteToast={onDeleteToast}
    />
  ) : (
    <></>
  );
};

export default Toast;
